import { CorporateAdminProfile } from '../model/corporate-admin-profile';
import { ProfessionalAdminProfile } from '../model/professional-admin-profile';
export class AdminProfileBuilder {
    static buildAdminProfile(data) {
        let profile;
        if (data.type === 200)
            profile = this.buildAdminCorporateProfile(data);
        else
            profile = new ProfessionalAdminProfile();
        profile.id = data.id;
        profile.monthly_invoice = data.monthly_invoice;
        profile.invoice_name = data.invoice_name;
        profile.invoice_nif = data.invoice_nif;
        profile.invoice_email = data.invoice_email;
        profile.invoice_address = data.invoice_address;
        profile.invoice_city = data.invoice_city;
        profile.invoice_state = data.invoice_state;
        profile.invoice_zip = data.invoice_zip;
        profile.invoice_country = data.invoice_country;
        return profile;
    }
    static buildAdminCorporateProfile(data) {
        let profile = new CorporateAdminProfile();
        profile.companyId = data.company_id;
        profile.costCenterId = data.costcenter_id;
        profile.invoicePerCostCenter = data.invoice_per_costcenter;
        profile.sendReservationCopy = data.send_reservation_copy;
        profile.sendInvoiceCopy = data.send_invoice_copy;
        profile.level = data.level;
        return profile;
    }
    static buildAdminProfessionalProfilePayload(profile) {
        return {
            monthly_invoice: profile.monthly_invoice,
            invoice_name: profile.invoice_name,
            invoice_nif: profile.invoice_nif,
            invoice_email: profile.invoice_email,
            invoice_address: profile.invoice_address,
            invoice_city: profile.invoice_city,
            invoice_state: profile.invoice_state,
            invoice_zip: profile.invoice_zip,
            invoice_country: profile.invoice_country
        };
    }
    static buildAdminCorporateProfilePayload(profile) {
        return {
            send_invoice_copy: profile.send_invoice_copy || profile.sendInvoiceCopy,
            send_reservation_copy: profile.send_reservation_copy || profile.sendReservationCopy
        };
    }
}
//# sourceMappingURL=admin-profile-builder.js.map